const config: { fallbackLocale: 'nl' } = {
	fallbackLocale: 'nl',
};

export default defineI18nConfig(() => config);
